<template>
  <UserCommonLayout :footer-class-name="'line'">
    <template #content>
      <LazyProSkillManagerMainTop :organization-name="companyName" />
      <LazyProSkillManagerCommonTabMenu :container-class-name="'containerDash-1480'"/>
      <LazyProSkillManagerMainContent />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {useLoadingStore} from '~/store/loading/loadingStore';
import {useOrganizationService} from '~~/application/composables/service/useOrganizationService';
import {useUserStore} from '~/store/user/userStore';

const userStore = useUserStore();
const loadingStore = useLoadingStore();
const organizationService = useOrganizationService();
const { guard } = usePermissionGuard();

const companyName = ref("");

const init = () => {
  Promise.all([organizationService.getOrganizationProSkillManagerInfo()]).then(resolve => {
    if(resolve[0].name){
      companyName.value = resolve[0].name.charAt(0).toUpperCase() + resolve[0].name.slice(1);
    }
    loadingStore.closeLoading();
  }).catch(() => {
    loadingStore.closeLoading();
  })
}

// ASMT-MANAGE-07: ProSkillManager 진입 권한 게이트(isPermissionManageAssessment || isSuperAdminType)
const handlerAssessmentMenuDoNotHavePermission = () => {
  if (!guard(
      userStore.isPermissionManageAssessment ||
      userStore.isSuperAdminType
  )) return;
}

onMounted(() => {
  handlerAssessmentMenuDoNotHavePermission();
  init();
});

onActivated(() => {
  loadingStore.closeLoading();
  handlerAssessmentMenuDoNotHavePermission();
  init();
})

</script>

<style>
@import "~/assets/scss/business_style.scss";
</style>